import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// 中文翻译
const zhCN = {
  translation: {
    // 认证相关
    'auth.title': 'AI Chart Studio',
    'auth.subtitle': '登录或注册以访问系统',
    'auth.email': '邮箱地址',
    'auth.password': '密码',
    'auth.confirmPassword': '确认密码',
    'auth.signIn': '登录',
    'auth.signUp': '注册',
    'auth.signOut': '退出登录',
    'auth.signingIn': '登录中...',
    'auth.signingUp': '注册中...',
    'auth.verificationCode': '验证码',
    'auth.verify': '验证',
    'auth.verifying': '验证中...',
    'auth.resendCode': '重新发送验证码',
    'auth.signInWithGoogle': '使用 Google 登录',
    'auth.signUpWithGoogle': '使用 Google 注册',
    'auth.noAccount': '还没有账户？',
    'auth.hasAccount': '已有账户？',
    'auth.createAccount': '立即注册',
    'auth.loginNow': '立即登录',
    'auth.backToLogin': '返回登录',
    'auth.verificationSent': '我们已向 {email} 发送了验证码',
    'auth.verificationSuccess': '验证成功，请登录',
    'auth.verificationFailed': '验证失败',
    'auth.loginSuccess': '登录成功',
    'auth.loginFailed': '登录失败',
    'auth.signupSuccess': '注册成功，请查收验证邮件',
    'auth.signupFailed': '注册失败',
    'auth.passwordMismatch': '两次输入的密码不一致',
    'auth.passwordTooShort': '密码长度至少8位',
    'auth.enterEmail': '请输入邮箱',
    'auth.enterPassword': '请输入密码',
    'auth.enterVerificationCode': '请输入验证码',
    'auth.googleLoginFailed': 'Google登录失败',
    'auth.resendFailed': '重新发送失败',
    'auth.resendSuccess': '验证码已重新发送',
    'auth.incorrectPassword': '密码错误，请重新输入',
    'auth.forgotPassword': '忘记密码？',
    'auth.resetPassword': '重置密码',
    'auth.resetPasswordTitle': '重置密码',
    'auth.sendResetCode': '发送验证码',
    'auth.sendingResetCode': '发送中...',
    'auth.resetCodeSent': '验证码已发送到您的邮箱',
    'auth.newPassword': '新密码',
    'auth.confirmNewPassword': '确认新密码',
    'auth.resetPasswordSuccess': '密码重置成功，请使用新密码登录',
    'auth.resetPasswordFailed': '密码重置失败',
    'auth.resendVerificationCode': '重新发送验证码',
    
    // 导航
    'nav.chartAnalysis': '图表分析',
    'nav.strategyManagement': '策略管理',
    'nav.signalManagement': '信号管理',
    'nav.chartShort': '图表',
    'nav.signalsShort': '信号',
    'nav.aiChartStudio': 'AI Chart Studio',
    'nav.documentation': '文档',
    'nav.tutorial': '教程',
    'nav.systemOnline': '系统在线',
    'nav.systemOffline': '系统离线',

    // 通知
    'notification.title': '通知',
    'notification.markAllRead': '全部已读',
    'notification.noAlerts': '暂无提醒',
    'notification.alertTriggered': '信号触发',
    'notification.price': '价格',
    
    // 分析页面
    'analysis.similarIntervalList': '相似区间列表',
    'analysis.subsequentReturnAnalysis': '后续收益分析',
    'analysis.targetArea': '目标区域',
    'analysis.similarIntervalCount': '相似区间数量',
    'analysis.correlationCoefficient': '相关系数',
    'analysis.highSimilarity': '高相似度',
    'analysis.view': '查看',
    'analysis.futureKline': '未来K-lines',
    'analysis.saveAsSignal': '保存为信号',
    'analysis.startAnalysis': '开始分析',
    'analysis.currentSelectedArea': '当前选择区域',
    'analysis.noAreaSelected': '未选择区域',
    'analysis.noSimilarIntervals': '暂无相似区间',
    'analysis.similarityAnalysis': 'K-lines相似性分析',
    'analysis.aiIntelligentAnalysis': 'AI智能分析',
    'analysis.signalPointAnalysis': '信号点相似性分析',
    'analysis.miniKlines': '迷你K-lines',
    'analysis.center': '中心',
    'analysis.currentSelectedPoint': '当前选中点',
    'analysis.noPointSelected': '未选择点',
    'analysis.signalPointAnalysisButton': '信号点分析',
    'analysis.analyzing': '正在分析中...',
    'analysis.similarPointList': '相似点列表',
    'analysis.similarPointCount': '相似点数量',
    'analysis.time': '时间',
    'analysis.futureKlineAverageReturn': '未来{{count}} K-lines平均收益率',
    'analysis.noData': '无数据',
    'analysis.noAnalysisData': '暂无分析数据',
    'analysis.aiAnalysis': 'AI分析',
    'analysis.noAiAnalysisResult': '暂无AI分析结果',
    'analysis.klineSimilarityAnalysis': 'K-lines相似性分析',
    'analysis.similarIntervalAndFutureKline': '相似区间+未来30 K-lines',
    'analysis.averageReturn': '平均收益',
    'analysis.winRate': '胜率',
    'analysis.sampleSize': '样本数',
    'analysis.standardDeviation': '标准差',
    'analysis.riskAdjustment': '风险调整',
    'analysis.maxDrawdown': '最大回撤',
    'analysis.trendStrength': '趋势强度',
    'analysis.volatility': '波动率',
    'analysis.returnDistribution': '收益分布',
    'analysis.rectangleAnalysis': '矩形分析',
    'analysis.visualization': '数据可视化',
    'analysis.returnComparison': '收益对比',
    'analysis.riskMetrics': '风险指标',
    'analysis.win': '盈利',
    'analysis.loss': '亏损',
    'analysis.keyMetrics': '关键指标',
    'analysis.returnAndWinRate': '收益与胜率',
    'analysis.performanceDashboard': '表现仪表板',
    'analysis.period': '周期',
    'analysis.reliableData': '可靠数据',
    'analysis.riskLevel': '风险水平',
    'analysis.winRateTable': '胜率表格',
    'analysis.similarityRank': '相似度排名',
    'analysis.highWinRate': '高胜率',
    'analysis.mediumWinRate': '中等胜率',
    'analysis.lowWinRate': '低胜率',
    'analysis.winRateHeatmap': '胜率热力图',
    'analysis.averageReturnTable': '平均收益表格',
    'analysis.highReturn': '高收益',
    'analysis.positiveReturn': '正收益',
    'analysis.slightPositive': '微正收益',
    'analysis.slightNegative': '微负收益',
    'analysis.negativeReturn': '负收益',
    'analysis.highLoss': '大亏损',
    'analysis.suggestion.title': '趋势建议',
    'analysis.suggestion.bullish': '强烈看涨',
    'analysis.suggestion.slightlyBullish': '温和看涨',
    'analysis.suggestion.sideways': '震荡整理',
    'analysis.suggestion.slightlyBearish': '温和看跌',
    'analysis.suggestion.bearish': '强烈看跌',
    'analysis.volatility.low': '低波动',
    'analysis.volatility.medium': '中等波动',
    'analysis.volatility.high': '高波动',
    'analysis.volatility.extreme': '极高波动',
    'analysis.volatility.lowDesc': '波动率 ≤ 2.0，风险较低，价格相对稳定',
    'analysis.volatility.mediumDesc': '波动率 2.0-5.0，中等风险，价格有一定波动',
    'analysis.volatility.highDesc': '波动率 5.0-10.0，高风险，价格波动较大',
    'analysis.volatility.extremeDesc': '波动率 > 10.0，极高风险，价格剧烈波动',
    'analysis.volatility.standard': '波动率标准',
    'analysis.similarInterval': '相似区间',
            'analysis.dashboardNote': '显示Top 10相似度排名的20 K-lines数据',
        'analysis.confidenceScore': '信心分数',
        'analysis.similarPatternAnalysis': '趋势分析',
        
        // Pattern Validation (Before vs After)
        'analysis.split.title': '模式验证',
        'analysis.split.tab': '验证分析',
        'analysis.split.description': '对比所选点前后的模式表现',
        'analysis.split.all': '全部',
        'analysis.split.discovery': '之前',
        'analysis.split.validation': '之后',
        'analysis.split.discoveryDesc': '选定点之前的历史模式',
        'analysis.split.validationDesc': '选定点之后的未来模式',
        'analysis.split.samples': '样本',
        'analysis.split.noData': '暂无验证数据',
        'analysis.split.noValidation': '没有验证数据。所有相似模式都在选定点之前。',
        'analysis.split.insightGood': '模式表现稳定。"之后"验证了"之前"的有效性。',
        'analysis.split.insightWarning': '"之后"表现明显下降。可能存在过拟合风险。',
        'analysis.split.insightNeutral': '"之前"与"之后"结果存在差异，建议谨慎对待。',
        'analysis.split.hint': '"之前"与"之后"表现一致说明模式更可靠。',
        'analysis.split.tooltip': '"之前"展示历史模式表现。"之后"展示选定点之后的表现——这是模式有效性的真正测试。',
        
        // Realtime  
    'realtime.connected': '已连接',
        'realtime.disconnected': '连接断开',
    'realtime.connectedTooltip': '已连接 {{symbol}} {{interval}} - 最新价格: ${{price}}',
        'realtime.symbol': '交易对',
        'realtime.interval': '周期',
        'realtime.latestPrice': '最新价格',
        'realtime.lastUpdate': '最后更新',
        'realtime.mode': '模式',
        'realtime.liveMode': '实时模式',
        'realtime.cachedMode': '缓存模式',

    // 通用功能占位
    'feature.comingSoon.title': '功能暂未开放',
    'feature.comingSoon.subtitle': '该功能正在研发中，敬请期待上线。',

    // 指标面板
    'indicator.panel.title': '指标',
    'indicator.panel.subtitle': '从下方选择当前支持的指标。',
    'indicator.placement.label': '显示位置',
    'indicator.placement.main': '主图',
    'indicator.placement.pane': '新建子图',
    'indicator.add': '添加',
    'indicator.added': '已添加',
    'indicator.limit.currentPlan': '当前套餐',
    'indicator.limit.recommendedPlan': '推荐套餐',
    'indicator.limit.unlimited': '无限制',
    'indicator.limit.upgradeBenefits': '升级后可解锁：',
    'indicator.limit.benefitAllIndicators': '全部高级指标，无限制叠加',
    'indicator.limit.benefitPriority': '优先数据与客服支持',
    'indicator.limit.benefitFaster': '更快的行情与分析响应',
    'indicator.limit.cta': '升级为 Pro Trader',
    'indicator.button': '指标',
    'indicator.volume.label': '成交量',
    'indicator.volume.description': '在主图下方展示成交量柱状图。',
    'indicator.rsi.label': 'RSI 相对强弱',
    'indicator.rsi.description': '相对强弱指数，突出超买/超卖动能。',
    'indicator.macd.label': 'MACD',
    'indicator.macd.description': '指数平滑异同移动平均，使用快/慢EMA展示动能变化。',
    'indicator.sma.label': 'SMA 简单均线',
    'indicator.sma.description': '简单移动平均线叠加在价格上。',
    'indicator.ema.label': 'EMA 指数均线',
    'indicator.ema.description': '指数移动平均线叠加在价格上。',
    'indicator.wma.label': 'WMA 加权均线',
    'indicator.wma.description': '加权移动平均线叠加在价格上。',
    'indicator.wema.label': 'WEMA 威尔德均线',
    'indicator.wema.description': '威尔德平滑（平滑移动平均）叠加在价格上。',
    'indicator.typicalPrice.label': '典型价格',
    'indicator.typicalPrice.description': '(高+低+收)/3 的均值叠加在价格上。',
    'indicator.obv.label': 'OBV 能量潮',
    'indicator.obv.description': '展示累计成交量流向的子图。',
    'indicator.bollingerBands.label': '布林带',
    'indicator.bollingerBands.description': '价格周围的上/中/下轨 (20, 2σ)。',
    'indicator.williamsR.label': '威廉指标 %R',
    'indicator.williamsR.description': '动量振荡器，显示超买/超卖 (14)。',
    'indicator.atr.label': 'ATR 平均真实波幅',
    'indicator.atr.description': '显示波动率 (14)。',
    'indicator.mfi.label': 'MFI 资金流量指数',
    'indicator.mfi.description': '结合价格与成交量的动量/成交量振荡器 (14)。',
    'indicator.stochastic.label': '随机指标 %K/%D',
    'indicator.stochastic.description': '随机振荡器的 %K/%D 线 (14,3)。',
    'indicator.roc.label': 'ROC 变动率',
    'indicator.roc.description': '价格变动率动量 (14)。',
    'indicator.trix.label': 'TRIX 三重指数',
    'indicator.trix.description': '三重平滑变动率振荡器 (15)。',
    'indicator.vwap.label': 'VWAP 成交量加权均价',
    'indicator.vwap.description': '按交易时段的成交量加权平均价叠加。',
    'indicator.adl.label': 'ADL 累积/派发线',
    'indicator.adl.description': '基于成交量的资金流动线。',
    'indicator.adx.label': 'ADX 趋向指标',
    'indicator.adx.description': '包含 +DI/-DI 的平均趋向指标 (14)。',
    'indicator.ao.label': 'AO 绝佳振荡器',
    'indicator.ao.description': '5/34 周期的柱状图动量。',
    'indicator.cci.label': 'CCI 商品通道',
    'indicator.cci.description': '商品通道指数振荡器 (20)。',
    'indicator.forceIndex.label': '能量指标',
    'indicator.forceIndex.description': '结合价格变化和成交量的能量指标 (13)。',
    'indicator.kst.label': 'KST 确然指标',
    'indicator.kst.description': '带信号线的动量指标。',
    'indicator.psar.label': 'PSAR 抛物线转向',
    'indicator.psar.description': '覆盖在价格上的抛物线点 (0.02, 0.2)。',
    'indicator.stochRsi.label': '随机RSI',
    'indicator.stochRsi.description': '带 %K/%D 线的随机 RSI 振荡器。',
    'indicator.volumeProfile.label': '成交量分布图',
    'indicator.volumeProfile.description': '可见区间的价格-成交量分布。',
    'indicator.ichimokuCloud.label': '一目均衡云',
    'indicator.ichimokuCloud.description': '包含转换/基准线与领先云区。',
    'stock.status': '状态',
    'stock.price': '价格',
    'market.open': '市场开放',
    'market.closed': '市场休市',
    'market.hoursNotice': '仅显示交易时段数据',
    
    // 工具按钮
    'tools.title': '工具',
    'tools.rectangleTool': '矩形工具',
    'tools.pointTool': '点工具',
    'tools.selectMode': '选择模式',
    'tools.exitRectangleTool': '退出矩形工具',
    'tools.removeRectangle': '移除矩形',
    'tools.exitPointTool': '退出点工具',
    'tools.clearPoints': '清除点',
    'tools.shortSelectionHint': '您选择的区间较短（仅 {{count}} 根K线），建议选择 10 根左右或以上效果更佳。',
    'tools.dontShowAgain': '不再显示此提示',
    
    // 聊天界面
    'chat.signalAssistant': '信号分析助手',
    'chat.selectSignal': '选择信号',
    'chat.multipleSelect': '(可多选)',
    'chat.sendMessage': '发送消息',
    'chat.placeholder': '请输入您的问题...',
    'chat.startConversationAfterSelect': '选择信号后开始对话',
    'chat.canAskQuestions': '可以询问信号分析、历史表现、操作建议等问题',
    'chat.enterYourQuestion': '输入你的问题...',
    'chat.send': '发送',
    'chat.pleaseSelectSignalFirst': '请先选择要分析的信号,然后开始对话',
    
    // AI Agent
    'agent.tab': 'AI 智能体',
    'agent.emptyHint': '向我描述你想分析什么',
    'agent.emptyExample': '例如: "帮我分析最近的低点" 或 "分析20根K线前的点位"',
    'sidebar.assistance': '辅助',
    'agent.title': '',
    'agent.welcome': '我是策略发现助手，可以帮你找到交易机会',
    'agent.inputPlaceholder': '描述你想要的交易策略...',
    'agent.sendError': '发送消息失败',
    'agent.prompts.findOpportunity': '帮我分析BTC最近有什么机会',
    'agent.prompts.findPattern': '找一下ETH的形态信号',
    'agent.prompts.findBuyPoint': '帮我找BTC的买入点',
    'agent.tools.discoverRectangle': '发现形态候选',
    'agent.tools.discoverPoint': '发现关键点',
    'agent.tools.analyzeRectangle': '分析形态',
    'agent.tools.analyzePoint': '分析点位',
    'agent.tools.showPanel': '展示面板',
    'agent.tools.setChartContext': '切换市场',
    'agent.tools.selectRectangleArea': '选择矩形',
    'agent.tools.analyzeRectangleArea': '分析矩形',
    'agent.tools.listIndicators': '指标库',
    'agent.tools.setIndicators': '选择指标',
    // Agent transparency & settings
    'agent.settings': 'Agent 设置',
    'agent.riskProfile': '风险偏好',
    'agent.transparencyMode': '透明度',
    'agent.customInstructions': '自定义指令',
    'agent.customInstructionsPlaceholder': '例如：更激进一些，偏突破，回答简洁，直接给入场/失效条件…',
    'agent.customInstructionsNote': '说明：仅作为偏好，无法覆盖合规/安全规则（例如禁止承诺保证收益）。',
    'agent.conservative': '保守',
    'agent.balanced': '均衡',
    'agent.aggressive': '激进',
    'agent.transparency': '透明度',
    'agent.evidence': '证据',
    'agent.assumptions': '假设',
    'agent.risks': '风险',
    'agent.toolsUsed': '使用的工具',
    'agent.comingSoon.tag': '即将推出',
    'agent.comingSoon.title': 'AI 策略 Agent 即将上线',
    'agent.comingSoon.subtitle': '首个量化 Agent —— 自动发现信号、构建策略，并与你一起迭代优化。',
    'agent.comingSoon.note': '当前仅为预览，功能暂未开放。',
    'agent.comingSoon.center': 'AI 策略 Agent 预告 — 即将推出',
    'agent.comingSoon.toast': 'AI 策略 Agent 即将上线，敬请期待！',
    
    // 信号管理
    'signal.name': '信号名称',
    'signal.description': '信号描述',
    'signal.createdAt': '创建时间',
    'signal.updatedAt': '更新时间',
    'signal.actions': '操作',
    'signal.edit': '编辑',
    'signal.delete': '删除',
    'signal.load': '加载',
    'signal.save': '保存',
    'signal.cancel': '取消',
    'signal.confirm': '确认',
    'signal.view': '查看',
    'signal.newSignal': '新信号',
    'signal.loadFailed': '加载信号失败',
    'signal.deleteSuccess': '信号删除成功！',
    'signal.deleteFailed': '删除失败',
    'signal.saveSuccess': '信号保存成功！',
    'signal.saveFailed': '保存信号失败',
    'signal.editSuccess': '信号编辑成功！',
    'signal.editFailed': '编辑信号失败',
    'signal.noSignals': '暂无保存的信号',
    'signal.signalManagement': '信号管理',
    'signal.saveSignal': '保存信号',
    'signal.newSignalPlaceholder': '新信号',
    'signal.descriptionOptionalPlaceholder': '可选: 描述这个信号的特点或使用场景',
    'signal.timeRange': '时间范围',
    'signal.confirmDelete': '确定要删除这个信号吗？',
    'signal.deleteWarning': '删除后无法恢复',
    'signal.namePlaceholder': '请输入信号名称，如：信号一',
    'signal.completeAnalysisHint': '完成分析后可以点击"保存信号"按钮',
    'signal.analysisDetails': '分析详情',
    'signal.symbol': '交易对',
    'signal.timeframe': '时间周期',
    
    // 通用
    'common.language': '语言',
    'common.loading': '加载中...',
    'common.close': '关闭',
    'common.enlarge': '放大',
    'common.error': '错误',
    'common.success': '成功',
    'common.cancel': '取消',
    'common.confirm': '确认',
    'common.ok': '确定',
    'common.save': '保存',
    'common.delete': '删除',
    'common.retry': '重试',
    'common.edit': '编辑',
    'common.view': '查看',
    'common.unit': '个',
    'common.refresh': '刷新',
    
    // 错误信息
    'error.networkError': '网络错误',
    'error.serverError': '服务器错误',
    'error.unknownError': '未知错误',
    'error.analysisFailed': '分析失败',
    'error.noData': '暂无数据',
    
    // 时间格式
    'time.justNow': '刚刚',
    'time.minutesAgo': '{{count}}分钟前',
    'time.hoursAgo': '{{count}}小时前',
    'time.daysAgo': '{{count}}天前',
    // 资产类型
    'asset.crypto': '加密货币',
    'asset.stocks': '股票',
    
    // 问卷相关
    'questionnaire.title': '用户问卷',
    'questionnaire.subtitle': '请填写以下信息，帮助我们更好地为您提供服务',
    'questionnaire.age': '年龄范围',
    'questionnaire.gender': '性别',
    'questionnaire.tradingExperience': '炒股时间',
    'questionnaire.watchFrequency': '看盘频率',
    'questionnaire.submit': '提交问卷',
    'questionnaire.submitting': '提交中...',
    'questionnaire.submitSuccess': '问卷提交成功！',
    'questionnaire.submitFailed': '问卷提交失败',
    'questionnaire.ageRequired': '请选择您的年龄范围',
    'questionnaire.genderRequired': '请选择您的性别',
    'questionnaire.tradingExperienceRequired': '请选择您的炒股经验',
    'questionnaire.watchFrequencyRequired': '请选择您的看盘频率',
    'questionnaire.ageOptions.18-24': '18-24岁',
    'questionnaire.ageOptions.25-30': '25-30岁',
    'questionnaire.ageOptions.31-40': '31-40岁',
    'questionnaire.ageOptions.41-50': '41-50岁',
    'questionnaire.ageOptions.51-60': '51-60岁',
    'questionnaire.ageOptions.60+': '60岁以上',
    'questionnaire.genderOptions.male': '男',
    'questionnaire.genderOptions.female': '女',
    'questionnaire.genderOptions.other': '其他',
    'questionnaire.tradingExperienceOptions.0-1年': '0-1年',
    'questionnaire.tradingExperienceOptions.1-3年': '1-3年',
    'questionnaire.tradingExperienceOptions.3-5年': '3-5年',
    'questionnaire.tradingExperienceOptions.5-10年': '5-10年',
    'questionnaire.tradingExperienceOptions.10年以上': '10年以上',
    'questionnaire.watchFrequencyOptions.每天': '每天',
    'questionnaire.watchFrequencyOptions.每周几次': '每周几次',
    'questionnaire.watchFrequencyOptions.偶尔': '偶尔',
    'questionnaire.watchFrequencyOptions.很少': '很少',

    // 教程相关
    'tutorial.welcome': '欢迎使用 AI Chart Studio',
    'tutorial.welcomeSubtitle': '观看以下教程视频，快速上手我们的分析工具',
    'tutorial.rectangleTool': '矩形工具',
    'tutorial.pointTool': '点工具',
    'tutorial.rectangleToolTitle': '矩形区域选择工具',
    'tutorial.rectangleToolDescription': '使用矩形工具可以选择图表上的任意K线区间，系统将自动分析该区间的历史相似形态，并预测未来走势。这是进行技术分析的核心工具之一。',
    'tutorial.pointToolTitle': '信号点标记工具',
    'tutorial.pointToolDescription': '使用点工具可以在图表上标记特定的信号点，系统将分析该点附近的历史相似信号，帮助你判断当前市场状态和可能的交易机会。',
    'tutorial.howToUse': '使用步骤：',
    'tutorial.rectangleStep1': '点击工具栏中的矩形图标激活工具',
    'tutorial.rectangleStep2': '在图表上按住鼠标左键拖拽，选择目标K线区间',
    'tutorial.rectangleStep3': '释放鼠标完成选择，选中区域会高亮显示',
    'tutorial.rectangleStep4': '在下方分析面板中查看相似形态和AI分析结果',
    'tutorial.pointStep1': '点击工具栏中的瞄准图标激活工具',
    'tutorial.pointStep2': '在图表上点击选择目标K线位置',
    'tutorial.pointStep3': '系统会自动标记该点并开始分析',
    'tutorial.pointStep4': '在下方分析面板中查看相似信号点分析',
    'tutorial.videoPlaceholder': '教程视频加载中...',
    'tutorial.rectangleVideoDesc': '学习如何使用矩形工具进行区间分析',
    'tutorial.pointVideoDesc': '学习如何使用点工具进行信号分析',
    'tutorial.strategyBuilderToolTitle': '策略生成器',
    'tutorial.strategyBuilderToolDescription': '使用策略生成器可以快速创建和回测量化交易策略。通过直观的界面设置入场条件、出场规则和风险管理参数，系统将自动回测历史数据并生成详细的策略表现报告。',
    'tutorial.strategyBuilderStep1': '点击工具栏中的策略生成器图标',
    'tutorial.strategyBuilderStep2': '设置策略的入场条件和技术指标参数',
    'tutorial.strategyBuilderStep3': '配置出场规则、止盈止损和仓位管理',
    'tutorial.strategyBuilderStep4': '运行回测查看策略历史表现和详细统计',
    'tutorial.strategyBuilderVideoDesc': '学习如何使用策略生成器创建量化策略',
    'tutorial.aiAgentToolTitle': 'AI 量化 Agent',
    'tutorial.aiAgentToolDescription': 'AI 量化 Agent 是您的智能交易助手。通过自然语言对话，AI 可以帮助您分析市场、生成策略建议、解读技术指标，并提供实时的交易决策支持。让 AI 成为您的私人量化分析师。',
    'tutorial.aiAgentStep1': '点击右侧的 AI Agent 面板打开对话窗口',
    'tutorial.aiAgentStep2': '用自然语言描述您的分析需求或交易想法',
    'tutorial.aiAgentStep3': 'AI 将分析市场数据并提供专业建议',
    'tutorial.aiAgentStep4': '根据 AI 建议调整策略或执行交易',
    'tutorial.aiAgentVideoDesc': '学习如何使用 AI Agent 进行智能量化分析',
    'tutorial.skipForNow': '稍后再看',
    'tutorial.nextTool': '下一个工具',
    'tutorial.prevTool': '上一个工具',
    'tutorial.complete': '完成教程',
    'tutorial.gotIt': '我知道了',
    'tutorial.helpButton': '使用帮助',
    'tutorial.watchTutorial': '观看教程',

    // Onboarding 入门引导
    'onboarding.skip': '跳过引导',
    'onboarding.previous': '上一步',
    'onboarding.next': '下一步',
    'onboarding.getStarted': '开始探索',
    'onboarding.welcomeStep': '欢迎',
    'onboarding.rectangleStep': '矩形工具',
    'onboarding.pointStep': '点工具',
    'onboarding.strategyBuilderStep': '策略生成器',
    'onboarding.aiAgentStep': 'AI Agent',
    'onboarding.welcomeTitle': 'Welcome to Alphora AI',
    'onboarding.welcomeSubtitle': '下一代 AI 量化图表工作室',
    'onboarding.welcomeDescription': '我们正在打造新一代的 AI 驱动量化分析平台。目前产品处于 Alpha 测试阶段，部分功能仍在持续优化中。感谢你的支持与反馈！',
    'onboarding.alphaNotice': '🚀 Alpha Version - 持续迭代中',
    'onboarding.toolsIntro': '以下是目前可用的核心工具：',
    'onboarding.feature1': 'AI 矩形区间分析',
    'onboarding.feature1Desc': 'AI 驱动的形态识别引擎，智能匹配历史相似 K 线区间，预测未来走势概率',
    'onboarding.feature2': 'AI 信号点识别',
    'onboarding.feature2Desc': 'AI 驱动的信号检测系统，自动分析关键点位的历史相似信号与后续表现',
    'onboarding.feature3': '策略生成器',
    'onboarding.feature3Desc': '快速创建和回测量化策略，通过直观界面设置入场出场规则，自动生成详细策略表现报告',
    'onboarding.feature4': 'AI 量化 Agent',
    'onboarding.feature4Desc': '端到端智能交易助手，通过自然语言对话分析市场、生成策略建议，让 AI 成为你的私人量化分析师',

    // 用户资料 / 订阅
    'profile.accountSettings': '账户设置',
    'profile.accountSettingsSubtitle': '管理你的个人信息和订阅套餐。',
    'profile.badge.eliteStatus': '尊享会员',
    'profile.badge.proMember': '专业会员',
    'profile.badge.currentPlan': '当前套餐',
    'profile.badge.active': '已激活',
    'profile.plan.usageTitle': '每日 AI 分析',
    'profile.plan.tokensUsed': '{{used}} / {{limit}} 次已使用',
    'profile.plan.manage': '管理套餐',
    'profile.plan.upgrade': '升级套餐',
    'profile.plan.manageSubscription': '管理订阅',
    'profile.security.title': '安全',
    'profile.security.twoFactor': '双重验证',
    'profile.security.twoFactorSubtitle': '通过邮箱启用',
    'profile.security.password': '密码',
    'profile.security.passwordSubtitle': '上次修改于 1 个月前',
    'profile.security.update': '更新',
    'profile.personalInfo.title': '个人信息',
    'profile.personalInfo.firstName': '名',
    'profile.personalInfo.lastName': '姓',
    'profile.personalInfo.edit': '编辑',
    'profile.personalInfo.cancel': '取消',
    'profile.personalInfo.save': '保存',
    'profile.invite.title': '邀请好友',
    'profile.invite.subtitle': '每邀请一位好友可获得 +50 AI 额度',
    'profile.invite.button': '邀请',
    'profile.plan.renewsOn': '将在 {{date}} 自动续费',
    'profile.plan.endsOn': '将于 {{date}} 到期',
    'profile.messages.mustLoginUpdateProfile': '请登录后再修改个人信息。',
    'profile.messages.updateFailed': '更新个人信息失败',
    'profile.messages.updateSuccess': '个人信息已更新',
    'profile.messages.planUpgraded': '套餐已升级为 {{plan}}',
    'profile.messages.mustLoginManageSub': '请登录后再管理订阅。',
    'profile.messages.billingPortalFailed': '打开账单管理页面失败。',

    // 套餐选择
    'plans.title': '为你的交易旅程选择合适的套餐',
    'plans.subtitle': '可随时升级或降级，解锁 AI 驱动的市场分析能力。',
    'plans.backToProfile': '返回个人中心',
    'plans.mostPopular': '最受欢迎',
    'plans.starter.description': '适合刚开始进行基础图表分析的用户。',
    'plans.starter.feature.standardIndicators': '标准指标',
    'plans.starter.feature.dailyTokens': '每日 5 次 AI 分析额度',
    'plans.pro.description': '为进阶交易者提供实时数据和高级 AI 工具。',
    'plans.pro.feature.advancedIndicators': '高级技术指标（MACD、RSI 等）',
    'plans.pro.feature.dailyTokens': '每日 50 次 AI 分析额度',
    'plans.pro.feature.prioritySupport': '优先支持',
    'plans.enterprise.description': '为高频交易和财富管理提供无限动力。',
    'plans.enterprise.feature.unlimitedAI': '无限制 AI 分析',
    'plans.enterprise.feature.accountManager': '专属客户成功经理',
    'plans.enterprise.feature.apiAccess': 'API 访问',
    'plans.enterprise.feature.customStrategy': '定制策略开发',
    'plans.button.currentPlan': '当前套餐',
    'plans.button.notAvailable': '当前套餐不可降级',
    'plans.button.contactSales': '联系销售',
    'plans.button.selectPlan': '选择套餐',
    'plans.messages.alreadyStarter': '你已经在使用 Starter 免费套餐。',
    'plans.messages.priceIdNotConfigured': '配置错误：未设置价格 ID。',
    'plans.messages.mustLoginUpgrade': '请登录后再升级套餐。',
    'plans.messages.createCheckoutFailed': '创建结算会话失败。',
    'plans.messages.upgradeFailed': '升级失败：{{error}}',
    
    // Strategy Builder
    'nav.strategies': '策略',
    'strategyBuilder.buildStrategy': '构建策略',
    'strategyBuilder.editStrategy': '编辑策略',
    'strategyBuilder.myStrategies': '我的策略',
    'strategyBuilder.createNew': '新建策略',
    'strategyBuilder.createFirst': '创建您的第一个策略',
    'strategyBuilder.noStrategies': '暂无策略',
    'strategyBuilder.strategyName': '策略名称',
    'strategyBuilder.namePlaceholder': '名称',
    'strategyBuilder.asset': '资产',
    'strategyBuilder.timeframe': '时间周期',
    'strategyBuilder.buyConditions': '买入条件',
    'strategyBuilder.sellConditions': '卖出条件',
    'strategyBuilder.addSignal': '添加信号',
    'strategyBuilder.searchSignals': '搜索信号...',
    'strategyBuilder.selectBuySignal': '选择买入信号',
    'strategyBuilder.selectSellSignal': '选择卖出信号',
    'strategyBuilder.noSignalsSaved': '暂无已保存的信号，请先在图表分析中创建信号。',
    'strategyBuilder.noSignalsMatch': '没有匹配的信号',
    'strategyBuilder.noSignalsForFilter': '没有找到匹配当前资产和时间周期的信号，请先创建对应的信号。',
    'strategyBuilder.useSignalExit': '使用卖出信号',
    'strategyBuilder.takeProfit': '止盈',
    'strategyBuilder.stopLoss': '止损',
    'strategyBuilder.maxHoldingPeriod': '最大持仓时间',
    'strategyBuilder.hours': '小时',
    'strategyBuilder.days': '天',
    'strategyBuilder.tpslBackup': '使用信号出场时，止盈/止损作为备用出场',
    'strategyBuilder.saveStrategy': '保存策略',
    'strategyBuilder.backtestResults': '回测结果',
    'strategyBuilder.backtestComplete': '回测完成',
    'strategyBuilder.backtestFailed': '回测失败',
    'strategyBuilder.setExitRule': '请设置止盈或止损',
    'strategyBuilder.enterName': '请输入策略名称',
    'strategyBuilder.saveSuccess': '策略保存成功',
    'strategyBuilder.saveFailed': '保存策略失败',
    'strategyBuilder.loadFailed': '加载策略失败',
    'strategyBuilder.deleteSuccess': '策略已删除',
    'strategyBuilder.deleteFailed': '删除策略失败',
    'strategyBuilder.confirmDelete': '确定删除此策略？',
    'strategyBuilder.viewDetails': '查看',
    'strategyBuilder.createdAt': '创建于',
    'strategyBuilder.exitRule': '出场',
    'strategyBuilder.signalBased': '信号出场',
    'strategyBuilder.time': '时间',
    'strategyBuilder.desc': '描述',
    'strategyBuilder.summaryTab': '概览',
    'strategyBuilder.tradesTab': '交易历史',
    'strategyBuilder.winRate': '胜率',
    'strategyBuilder.totalReturn': '总收益',
    'strategyBuilder.sharpeRatio': '夏普比率',
    'strategyBuilder.maxDrawdown': '最大回撤',
    'strategyBuilder.profitFactor': '盈亏比',
    'strategyBuilder.totalTrades': '总交易次数',
    'strategyBuilder.avgReturn': '平均收益/笔',
    'strategyBuilder.avgHolding': '平均持仓时间',
    'strategyBuilder.sampleSize': '样本数量',
    'strategyBuilder.lowConfidence': '统计置信度较低',
    'strategyBuilder.entryTime': '入场时间',
    'strategyBuilder.entryPrice': '入场价格',
    'strategyBuilder.exitTime': '出场时间',
    'strategyBuilder.exitPrice': '出场价格',
    'strategyBuilder.return': '收益',
    'strategyBuilder.holdingPeriod': '持仓时间',
    'strategyBuilder.exitReason': '出场原因',
    'strategyBuilder.trades': '交易次数',
    'strategyBuilder.selectThisSignal': '选择此信号',
    'strategyBuilder.strategyPerformance': '策略表现',
    'strategyBuilder.askFollowUp': '问一个问题...',
    'strategyBuilder.waitingForAnalysis': '等待AI分析...',
    'strategyBuilder.equityCurve': '权益曲线',
    'strategyBuilder.clickToExpand': '点击展开',
    'strategyBuilder.recentTrades': '最近交易',
    'strategyBuilder.strategy': '策略',
    'strategyBuilder.library': '资料库',
    'strategyBuilder.selectStrategy': '选择策略',
    'strategyBuilder.selectOrBuildStrategy': '选择一个策略或创建新策略',
    'strategyBuilder.askAboutStrategy': '向 AI 询问策略表现...',
    'strategyBuilder.strategyLog': '策略记录',
    'strategyBuilder.description': '描述',
    'strategyBuilder.descriptionPlaceholder': '描述这个策略...',
    // Futures trading
    'strategyBuilder.tradingMode': '交易模式',
    'strategyBuilder.spot': '现货',
    'strategyBuilder.futures': '合约',
    'strategyBuilder.direction': '方向',
    'strategyBuilder.long': '做多',
    'strategyBuilder.short': '做空',
    'strategyBuilder.leverage': '杠杆',
    'strategyBuilder.leverageWarning': '反向波动 {{pct}}% 将爆仓',
    'strategyBuilder.liquidations': '次爆仓',
    'common.select': '选择',
    'common.back': '返回',
  }
};

// 英文翻译
const enUS = {
  translation: {
    // Authentication
    'auth.title': 'AI Chart Studio',
    'auth.subtitle': 'Sign in or register to access the system',
    'auth.email': 'Email Address',
    'auth.password': 'Password',
    'auth.confirmPassword': 'Confirm Password',
    'auth.signIn': 'Sign In',
    'auth.signUp': 'Sign Up',
    'auth.signOut': 'Sign Out',
    'auth.signingIn': 'Signing In...',
    'auth.signingUp': 'Signing Up...',
    'auth.verificationCode': 'Verification Code',
    'auth.verify': 'Verify',
    'auth.verifying': 'Verifying...',
    'auth.resendCode': 'Resend Code',
    'auth.signInWithGoogle': 'Sign in with Google',
    'auth.signUpWithGoogle': 'Sign up with Google',
    'auth.noAccount': "Don't have an account?",
    'auth.hasAccount': 'Already have an account?',
    'auth.createAccount': 'Sign up now',
    'auth.loginNow': 'Sign in now',
    'auth.backToLogin': 'Back to Sign In',
    'auth.verificationSent': 'We have sent a verification code to {email}',
    'auth.verificationSuccess': 'Verification successful, please sign in',
    'auth.verificationFailed': 'Verification failed',
    'auth.loginSuccess': 'Sign in successful',
    'auth.loginFailed': 'Sign in failed',
    'auth.signupSuccess': 'Registration successful, please check your email',
    'auth.signupFailed': 'Registration failed',
    'auth.passwordMismatch': 'Passwords do not match',
    'auth.passwordTooShort': 'Password must be at least 8 characters',
    'auth.enterEmail': 'Please enter email',
    'auth.enterPassword': 'Please enter password',
    'auth.enterVerificationCode': 'Please enter verification code',
    'auth.googleLoginFailed': 'Google sign in failed',
    'auth.resendFailed': 'Resend failed',
    'auth.resendSuccess': 'Verification code resent',
    'auth.incorrectPassword': 'Incorrect password, please try again',
    'auth.forgotPassword': 'Forgot password?',
    'auth.resetPassword': 'Reset Password',
    'auth.resetPasswordTitle': 'Reset Password',
    'auth.sendResetCode': 'Send Verification Code',
    'auth.sendingResetCode': 'Sending...',
    'auth.resetCodeSent': 'Verification code has been sent to your email',
    'auth.newPassword': 'New Password',
    'auth.confirmNewPassword': 'Confirm New Password',
    'auth.resetPasswordSuccess': 'Password reset successful, please sign in with your new password',
    'auth.resetPasswordFailed': 'Password reset failed',
    'auth.resendVerificationCode': 'Resend Verification Code',
    
    // Navigation
    'nav.chartAnalysis': 'Chart Analysis',
    'nav.strategyManagement': 'Strategy Management',
    'nav.signalManagement': 'Signal Management',
    'nav.chartShort': 'Chart',
    'nav.signalsShort': 'Signals',
    'nav.aiChartStudio': 'AI Chart Studio',
    'nav.documentation': 'Documentation',
    'nav.tutorial': 'Tutorial',
    'nav.systemOnline': 'System Online',
    'nav.systemOffline': 'System Offline',

    // Notifications
    'notification.title': 'Notifications',
    'notification.markAllRead': 'Mark all read',
    'notification.noAlerts': 'No alerts',
    'notification.alertTriggered': 'Signal triggered',
    'notification.price': 'Price',
    
    // Analysis page
    'analysis.similarIntervalList': 'Similar Interval List',
            'analysis.subsequentReturnAnalysis': 'Subsequent Return Analysis',
        'analysis.targetArea': 'Target Area',
        'analysis.similarIntervalCount': 'Similar Interval Count',
        'analysis.correlationCoefficient': 'Correlation Coefficient',
        'analysis.highSimilarity': 'High Similarity',
        'analysis.view': 'View',
        'analysis.futureKline': 'Future K-lines',
        'analysis.saveAsSignal': 'Save as Signal',
        'analysis.startAnalysis': 'Start Analysis',
        'analysis.currentSelectedArea': 'Current Selected Area',
        'analysis.noAreaSelected': 'No Area Selected',
        'analysis.noSimilarIntervals': 'No Similar Intervals',
        'analysis.similarityAnalysis': 'K-lines Similarity Analysis',
        'analysis.aiIntelligentAnalysis': 'AI Intelligent Analysis',
        'analysis.signalPointAnalysis': 'Signal Point Similarity Analysis',
        'analysis.miniKlines': 'Mini K-lines',
        'analysis.center': 'Center',
        'analysis.currentSelectedPoint': 'Current Selected Point',
        'analysis.noPointSelected': 'No Point Selected',
        'analysis.signalPointAnalysisButton': 'Signal Point Analysis',
        'analysis.analyzing': 'Analyzing...',
        'analysis.similarPointList': 'Similar Point List',
        'analysis.similarPointCount': 'Similar Point Count',
        'analysis.time': 'Time',
        'analysis.futureKlineAverageReturn': 'Future {{count}} K-lines Average Return',
        'analysis.noData': 'No Data',
        'analysis.noAnalysisData': 'No Analysis Data',
        'analysis.aiAnalysis': 'AI Analysis',
        'analysis.noAiAnalysisResult': 'No AI Analysis Result',
        'analysis.similarIntervalAndFutureKline': 'Similar Interval + Future 30 K-lines',
        'analysis.averageReturn': 'Average Return',
        'analysis.winRate': 'Win Rate',
        'analysis.sampleSize': 'Sample Size',
        'analysis.standardDeviation': 'Standard Deviation',
        'analysis.riskAdjustment': 'Risk Adjustment',
        'analysis.maxDrawdown': 'Max Drawdown',
        'analysis.trendStrength': 'Trend Strength',
        'analysis.volatility': 'Volatility',
        'analysis.returnDistribution': 'Return Distribution',
        'analysis.visualization': 'Data Visualization',
        'analysis.returnComparison': 'Return Comparison',
        'analysis.riskMetrics': 'Risk Metrics',
        'analysis.win': 'Win',
        'analysis.loss': 'Loss',
        'analysis.keyMetrics': 'Key Metrics',
        'analysis.returnAndWinRate': 'Return & Win Rate',
        'analysis.performanceDashboard': 'Performance Dashboard',
        'analysis.period': 'Period',
        'analysis.reliableData': 'Reliable Data',
        'analysis.riskLevel': 'Risk Level',
        'analysis.winRateTable': 'Win Rate Table',
        'analysis.similarityRank': 'Similarity Rank',
        'analysis.highWinRate': 'High Win Rate',
        'analysis.mediumWinRate': 'Medium Win Rate',
        'analysis.lowWinRate': 'Low Win Rate',
        'analysis.winRateHeatmap': 'Win Rate Heatmap',
        'analysis.averageReturnTable': 'Average Return Table',
        'analysis.highReturn': 'High Return',
        'analysis.positiveReturn': 'Positive Return',
        'analysis.slightPositive': 'Slight Positive',
        'analysis.slightNegative': 'Slight Negative',
        'analysis.negativeReturn': 'Negative Return',
        'analysis.highLoss': 'High Loss',
        'analysis.suggestion.title': 'Trend Suggestion',
        'analysis.suggestion.bullish': 'Strong Bullish',
        'analysis.suggestion.slightlyBullish': 'Slightly Bullish',
        'analysis.suggestion.sideways': 'Sideways',
        'analysis.suggestion.slightlyBearish': 'Slightly Bearish',
        'analysis.suggestion.bearish': 'Strong Bearish',
        'analysis.volatility.low': 'Low Volatility',
        'analysis.volatility.medium': 'Medium Volatility',
        'analysis.volatility.high': 'High Volatility',
        'analysis.volatility.extreme': 'Extreme Volatility',
        'analysis.volatility.lowDesc': 'Volatility ≤ 2.0, low risk, relatively stable prices',
        'analysis.volatility.mediumDesc': 'Volatility 2.0-5.0, medium risk, some price fluctuation',
        'analysis.volatility.highDesc': 'Volatility 5.0-10.0, high risk, significant price fluctuation',
        'analysis.volatility.extremeDesc': 'Volatility > 10.0, extreme risk, violent price fluctuation',
        'analysis.volatility.standard': 'Volatility Standard',
        'analysis.similarInterval': 'Similar Interval',
        'analysis.dashboardNote': 'Shows data from Top 10 similarity rank with 20 K-lines',
                'analysis.confidenceScore': 'Confidence Score',
        'analysis.similarPatternAnalysis': 'Trend Analysis',
        
        // Pattern Validation (Before vs After)
        'analysis.split.title': 'Pattern Validation',
        'analysis.split.tab': 'Validation',
        'analysis.split.description': 'Comparing pattern performance before vs after your selected point',
        'analysis.split.all': 'All',
        'analysis.split.discovery': 'Before',
        'analysis.split.validation': 'After',
        'analysis.split.discoveryDesc': 'Patterns before your point',
        'analysis.split.validationDesc': 'Patterns after your point',
        'analysis.split.samples': 'samples',
        'analysis.split.noData': 'No validation data available',
        'analysis.split.noValidation': 'No validation data available. All similar patterns are from before your selected point.',
        'analysis.split.insightGood': 'Pattern shows consistent performance. "After" confirms "Before".',
        'analysis.split.insightWarning': 'Significant performance drop in "After". May indicate overfitting.',
        'analysis.split.insightNeutral': 'Mixed results between "Before" and "After" periods.',
        'analysis.split.hint': 'Consistent performance between "Before" and "After" suggests a robust pattern.',
        'analysis.split.tooltip': '"Before" shows how patterns performed historically. "After" shows how they performed after your selection point - this is the true test of pattern effectiveness.',
        
        // Realtime
        'realtime.connected': 'Connected', 
        'realtime.disconnected': 'Disconnected',
        'realtime.connectedTooltip': 'Connected {{symbol}} {{interval}} - Latest price: ${{price}}',
        'realtime.symbol': 'Symbol',
        'realtime.interval': 'Interval',
        'realtime.latestPrice': 'Latest Price',
        'realtime.lastUpdate': 'Last Update',
        'realtime.mode': 'Mode',
        'realtime.liveMode': 'Live Mode',
        'realtime.cachedMode': 'Cached Mode',
        
        // Generic feature placeholder
        'feature.comingSoon.title': 'Coming Soon',
        'feature.comingSoon.subtitle': 'This feature is under development and will be available soon.',
        'analysis.rectangleAnalysis': 'Rectangle Analysis',
            'analysis.klineSimilarityAnalysis': 'K-lines Similarity Analysis',

    // Indicator panel
    'indicator.panel.title': 'Indicators',
    'indicator.panel.subtitle': 'Choose from the currently supported options below.',
    'indicator.placement.label': 'Placement',
    'indicator.placement.main': 'Main chart',
    'indicator.placement.pane': 'New pane',
    'indicator.add': 'Add',
    'indicator.added': 'Added',
    'indicator.limit.currentPlan': 'Current plan',
    'indicator.limit.recommendedPlan': 'Recommended',
    'indicator.limit.unlimited': 'Unlimited',
    'indicator.limit.upgradeBenefits': 'Upgrade to unlock:',
    'indicator.limit.benefitAllIndicators': 'All advanced indicators with no cap',
    'indicator.limit.benefitPriority': 'Priority data and support',
    'indicator.limit.benefitFaster': 'Faster market and analysis refresh',
    'indicator.limit.cta': 'Upgrade to Pro Trader',
    'indicator.button': 'Indicators',
    'indicator.volume.label': 'Volume',
    'indicator.volume.description': 'Displays traded volume bars beneath the main price chart.',
    'indicator.rsi.label': 'RSI',
    'indicator.rsi.description': 'Relative Strength Index highlights overbought/oversold momentum.',
    'indicator.macd.label': 'MACD',
    'indicator.macd.description': 'Moving Average Convergence Divergence shows momentum shifts using fast/slow EMAs.',
    'indicator.sma.label': 'SMA',
    'indicator.sma.description': 'Simple Moving Average overlay on price.',
    'indicator.ema.label': 'EMA',
    'indicator.ema.description': 'Exponential Moving Average overlay on price.',
    'indicator.wma.label': 'WMA',
    'indicator.wma.description': 'Weighted Moving Average overlay on price.',
    'indicator.wema.label': 'WEMA',
    'indicator.wema.description': 'Wilder’s smoothing (smoothed moving average) overlay on price.',
    'indicator.typicalPrice.label': 'Typical Price',
    'indicator.typicalPrice.description': 'Average of (high+low+close)/3 overlay on price.',
    'indicator.obv.label': 'OBV',
    'indicator.obv.description': 'On Balance Volume shows cumulative volume flow in a sub-pane.',
    'indicator.bollingerBands.label': 'Bollinger Bands',
    'indicator.bollingerBands.description': 'Upper/middle/lower bands around price (20, 2σ).',
    'indicator.williamsR.label': "Williams %R",
    'indicator.williamsR.description': 'Momentum oscillator showing overbought/oversold (14).',
    'indicator.atr.label': 'ATR',
    'indicator.atr.description': 'Average True Range shows volatility (14).',
    'indicator.mfi.label': 'MFI',
    'indicator.mfi.description': 'Money Flow Index momentum/volume oscillator (14).',
    'indicator.stochastic.label': 'Stochastic %K/%D',
    'indicator.stochastic.description': 'Stochastic oscillator with %K/%D lines (14,3).',
    'indicator.roc.label': 'ROC',
    'indicator.roc.description': 'Rate of Change momentum (14).',
    'indicator.trix.label': 'TRIX',
    'indicator.trix.description': 'Triple smoothed rate-of-change oscillator (15).',
    'indicator.vwap.label': 'VWAP',
    'indicator.vwap.description': 'Volume Weighted Average Price overlay (session-based).',
    'indicator.adl.label': 'ADL',
    'indicator.adl.description': 'Accumulation/Distribution Line (volume-based flow).',
    'indicator.adx.label': 'ADX',
    'indicator.adx.description': 'Average Directional Index with +DI/-DI (14).',
    'indicator.ao.label': 'AO',
    'indicator.ao.description': 'Awesome Oscillator (5,34) histogram.',
    'indicator.cci.label': 'CCI',
    'indicator.cci.description': 'Commodity Channel Index oscillator (20).',
    'indicator.forceIndex.label': 'Force Index',
    'indicator.forceIndex.description': 'Force Index oscillator (13) combining price change and volume.',
    'indicator.kst.label': 'KST',
    'indicator.kst.description': 'Know Sure Thing momentum oscillator with signal line.',
    'indicator.psar.label': 'PSAR',
    'indicator.psar.description': 'Parabolic SAR dots overlaid on price (0.02, 0.2).',
    'indicator.stochRsi.label': 'StochRSI',
    'indicator.stochRsi.description': 'Stochastic RSI oscillator with %K/%D lines.',
    'indicator.volumeProfile.label': 'Volume Profile',
    'indicator.volumeProfile.description': 'Price-level volume distribution over the visible range.',
    'indicator.ichimokuCloud.label': 'Ichimoku Cloud',
    'indicator.ichimokuCloud.description': 'Ichimoku Cloud with conversion/base lines and leading spans.',
    'stock.status': 'Status',
    'stock.price': 'Price',
    'market.open': 'Market Open',
    'market.closed': 'Market Closed',
    'market.hoursNotice': 'Showing market hours data only',
    
    // Tools
    'tools.title': 'Tools',
    'tools.rectangleTool': 'Rectangle Tool',
    'tools.pointTool': 'Point Tool',
    'tools.selectMode': 'Select Mode',
    'tools.exitRectangleTool': 'Exit Rectangle Tool',
    'tools.removeRectangle': 'Remove Rectangle',
    'tools.exitPointTool': 'Exit Point Tool',
    'tools.clearPoints': 'Clear Points',
    'tools.shortSelectionHint': 'The selected range is short (only {{count}} candles). We recommend selecting around 10 or more candles for better results.',
    'tools.dontShowAgain': 'Don\'t show this again',
    
    // Chat interface
    'chat.signalAssistant': 'Signal Analysis Assistant',
    'chat.selectSignal': 'Select Signal',
    'chat.multipleSelect': '(Multiple Select)',
    'chat.sendMessage': 'Send Message',
    'chat.placeholder': 'Please enter your question...',
    'chat.startConversationAfterSelect': 'Start conversation after selecting signal',
    'chat.canAskQuestions': 'You can ask about signal analysis, historical performance, operational suggestions, etc.',
    'chat.enterYourQuestion': 'Enter your question...',
    'chat.send': 'Send',
    'chat.pleaseSelectSignalFirst': 'Please select the signal to analyze first',
    
    // AI Agent
    'agent.tab': 'AI Agent',
    'agent.emptyHint': 'Tell me what you want to analyze',
    'agent.emptyExample': 'For example: "Analyze the recent low" or "Analyze the point 20 bars ago"',
    'sidebar.assistance': 'Assistance',
    'agent.title': '',
    'agent.welcome': 'I am your strategy discovery assistant, I can help you find trading opportunities',
    'agent.inputPlaceholder': 'Describe the trading strategy you want...',
    'agent.sendError': 'Failed to send message',
    'agent.prompts.findOpportunity': 'Help me analyze recent BTC opportunities',
    'agent.prompts.findPattern': 'Find ETH pattern signals',
    'agent.prompts.findBuyPoint': 'Help me find BTC buy points',
    'agent.tools.discoverRectangle': 'Discovering patterns',
    'agent.tools.discoverPoint': 'Discovering key points',
    'agent.tools.analyzeRectangle': 'Analyzing pattern',
    'agent.tools.analyzePoint': 'Analyzing point',
    'agent.tools.showPanel': 'Show panel',
    'agent.tools.setChartContext': 'Switch market',
    'agent.tools.selectRectangleArea': 'Select rectangle',
    'agent.tools.analyzeRectangleArea': 'Analyze rectangle',
    'agent.tools.listIndicators': 'List indicators',
    'agent.tools.setIndicators': 'Set indicators',
    // Agent transparency & settings
    'agent.settings': 'Agent settings',
    'agent.riskProfile': 'Risk profile',
    'agent.transparencyMode': 'Transparency',
    'agent.customInstructions': 'Custom instructions',
    'agent.customInstructionsPlaceholder': 'E.g. be more aggressive, focus on breakouts, keep it concise…',
    'agent.customInstructionsNote': 'Note: preferences only; cannot override safety/guarantee-profit rules.',
    'agent.conservative': 'Conservative',
    'agent.balanced': 'Balanced',
    'agent.aggressive': 'Aggressive',
    'agent.transparency': 'Transparency',
    'agent.evidence': 'Evidence',
    'agent.assumptions': 'Assumptions',
    'agent.risks': 'Risks',
    'agent.toolsUsed': 'Tools used',
    'agent.comingSoon.tag': 'Coming Soon',
    'agent.comingSoon.title': 'AI Strategy Agent is launching soon',
    'agent.comingSoon.subtitle': 'First ever quant agent — discover signals, build strategies, and iterate with you.',
    'agent.comingSoon.note': 'Preview only for now. Stay tuned.',
    'agent.comingSoon.center': 'AI Strategy Agent preview — coming soon',
    'agent.comingSoon.toast': 'AI Strategy Agent is coming soon. Stay tuned!',
    
    // Signal management
    'signal.name': 'Signal Name',
    'signal.description': 'Signal Description',
    'signal.createdAt': 'Created At',
    'signal.updatedAt': 'Updated At',
    'signal.actions': 'Actions',
    'signal.edit': 'Edit',
    'signal.delete': 'Delete',
    'signal.load': 'Load',
    'signal.save': 'Save',
    'signal.cancel': 'Cancel',
    'signal.confirm': 'Confirm',
    'signal.view': 'View',
    'signal.newSignal': 'New Signal',
    'signal.loadFailed': 'Failed to load signals',
    'signal.deleteSuccess': 'Signal deleted successfully!',
    'signal.deleteFailed': 'Delete failed',
    'signal.saveSuccess': 'Signal saved successfully!',
    'signal.saveFailed': 'Failed to save signal',
    'signal.editSuccess': 'Signal edited successfully!',
    'signal.editFailed': 'Failed to edit signal',
    'signal.noSignals': 'No saved signals',
    'signal.signalManagement': 'Signal Management',
    'signal.saveSignal': 'Save Signal',
    'signal.newSignalPlaceholder': 'New Signal',
    'signal.descriptionOptionalPlaceholder': 'Optional: Describe the characteristics or usage scenarios of this signal',
    'signal.timeRange': 'Time Range',
    'signal.confirmDelete': 'Are you sure you want to delete this signal?',
    'signal.deleteWarning': 'Cannot be recovered after deletion',
    'signal.namePlaceholder': 'Please enter signal name, e.g.: Signal One',
    'signal.completeAnalysisHint': 'After completing the analysis, you can click the "Save Signal" button',
    'signal.analysisDetails': 'Analysis Details',
    'signal.symbol': 'Symbol',
    'signal.timeframe': 'Timeframe',
    
    // Common
    'common.language': 'Language',
    'common.loading': 'Loading...',
    'common.close': 'Close',
    'common.enlarge': 'Enlarge',
    'common.error': 'Error',
    'common.success': 'Success',
    'common.cancel': 'Cancel',
    'common.confirm': 'Confirm',
    'common.ok': 'OK',
    'common.save': 'Save',
    'common.delete': 'Delete',
    'common.retry': 'Retry',
    'common.edit': 'Edit',
            'common.view': 'View',
                'common.unit': '',
        'common.refresh': 'Refresh',
    
    // Error messages
    'error.networkError': 'Network Error',
    'error.serverError': 'Server Error',
    'error.unknownError': 'Unknown Error',
    'error.analysisFailed': 'Analysis Failed',
    'error.noData': 'No Data',
    
    // Time format
    'time.justNow': 'Just Now',
    'time.minutesAgo': '{{count}} minutes ago',
    'time.hoursAgo': '{{count}} hours ago',
    'time.daysAgo': '{{count}} days ago',
    // Asset types
    'asset.crypto': 'Crypto',
    'asset.stocks': 'Stocks',
    
    // Questionnaire
    'questionnaire.title': 'User Questionnaire',
    'questionnaire.subtitle': 'Please fill in the following information to help us provide better service',
    'questionnaire.age': 'Age Range',
    'questionnaire.gender': 'Gender',
    'questionnaire.tradingExperience': 'Trading Experience',
    'questionnaire.watchFrequency': 'Chart Watching Frequency',
    'questionnaire.submit': 'Submit Questionnaire',
    'questionnaire.submitting': 'Submitting...',
    'questionnaire.submitSuccess': 'Questionnaire submitted successfully!',
    'questionnaire.submitFailed': 'Questionnaire submission failed',
    'questionnaire.ageRequired': 'Please select your age range',
    'questionnaire.genderRequired': 'Please select your gender',
    'questionnaire.tradingExperienceRequired': 'Please select your trading experience',
    'questionnaire.watchFrequencyRequired': 'Please select your chart watching frequency',
    'questionnaire.ageOptions.18-24': '18-24 years old',
    'questionnaire.ageOptions.25-30': '25-30 years old',
    'questionnaire.ageOptions.31-40': '31-40 years old',
    'questionnaire.ageOptions.41-50': '41-50 years old',
    'questionnaire.ageOptions.51-60': '51-60 years old',
    'questionnaire.ageOptions.60+': '60+ years old',
    'questionnaire.genderOptions.male': 'Male',
    'questionnaire.genderOptions.female': 'Female',
    'questionnaire.genderOptions.other': 'Other',
    'questionnaire.tradingExperienceOptions.0-1年': '0-1 years',
    'questionnaire.tradingExperienceOptions.1-3年': '1-3 years',
    'questionnaire.tradingExperienceOptions.3-5年': '3-5 years',
    'questionnaire.tradingExperienceOptions.5-10年': '5-10 years',
    'questionnaire.tradingExperienceOptions.10年以上': '10+ years',
    'questionnaire.watchFrequencyOptions.每天': 'Daily',
    'questionnaire.watchFrequencyOptions.每周几次': 'Several times a week',
    'questionnaire.watchFrequencyOptions.偶尔': 'Occasionally',
    'questionnaire.watchFrequencyOptions.很少': 'Rarely',

    // Tutorial
    'tutorial.welcome': 'Welcome to AI Chart Studio',
    'tutorial.welcomeSubtitle': 'Watch these tutorial videos to quickly get started with our analysis tools',
    'tutorial.rectangleTool': 'Rectangle Tool',
    'tutorial.pointTool': 'Point Tool',
    'tutorial.rectangleToolTitle': 'Rectangle Area Selection Tool',
    'tutorial.rectangleToolDescription': 'Use the rectangle tool to select any K-line interval on the chart. The system will automatically analyze similar historical patterns in that interval and predict future trends. This is one of the core tools for technical analysis.',
    'tutorial.pointToolTitle': 'Signal Point Marker Tool',
    'tutorial.pointToolDescription': 'Use the point tool to mark specific signal points on the chart. The system will analyze similar historical signals near that point, helping you assess the current market conditions and potential trading opportunities.',
    'tutorial.howToUse': 'How to use:',
    'tutorial.rectangleStep1': 'Click the rectangle icon in the toolbar to activate the tool',
    'tutorial.rectangleStep2': 'Hold down the left mouse button and drag on the chart to select the target K-line interval',
    'tutorial.rectangleStep3': 'Release the mouse to complete the selection, the selected area will be highlighted',
    'tutorial.rectangleStep4': 'View similar patterns and AI analysis results in the analysis panel below',
    'tutorial.pointStep1': 'Click the target icon in the toolbar to activate the tool',
    'tutorial.pointStep2': 'Click on the chart to select the target K-line position',
    'tutorial.pointStep3': 'The system will automatically mark the point and start analysis',
    'tutorial.pointStep4': 'View similar signal point analysis in the analysis panel below',
    'tutorial.videoPlaceholder': 'Tutorial video loading...',
    'tutorial.rectangleVideoDesc': 'Learn how to use the rectangle tool for interval analysis',
    'tutorial.pointVideoDesc': 'Learn how to use the point tool for signal analysis',
    'tutorial.strategyBuilderToolTitle': 'Strategy Builder',
    'tutorial.strategyBuilderToolDescription': 'Use the Strategy Builder to quickly create and backtest quantitative trading strategies. Set entry conditions, exit rules, and risk management parameters through an intuitive interface. The system will automatically backtest historical data and generate detailed strategy performance reports.',
    'tutorial.strategyBuilderStep1': 'Click the Strategy Builder icon in the toolbar',
    'tutorial.strategyBuilderStep2': 'Set up entry conditions and technical indicator parameters',
    'tutorial.strategyBuilderStep3': 'Configure exit rules, take profit/stop loss, and position sizing',
    'tutorial.strategyBuilderStep4': 'Run backtests to view historical performance and detailed statistics',
    'tutorial.strategyBuilderVideoDesc': 'Learn how to use the Strategy Builder to create quantitative strategies',
    'tutorial.aiAgentToolTitle': 'AI Quant Agent',
    'tutorial.aiAgentToolDescription': 'AI Quant Agent is your intelligent trading assistant. Through natural language conversation, AI can help you analyze markets, generate strategy recommendations, interpret technical indicators, and provide real-time trading decision support. Let AI become your personal quant analyst.',
    'tutorial.aiAgentStep1': 'Click the AI Agent panel on the right to open the chat window',
    'tutorial.aiAgentStep2': 'Describe your analysis needs or trading ideas in natural language',
    'tutorial.aiAgentStep3': 'AI will analyze market data and provide professional recommendations',
    'tutorial.aiAgentStep4': 'Adjust strategies or execute trades based on AI suggestions',
    'tutorial.aiAgentVideoDesc': 'Learn how to use AI Agent for intelligent quantitative analysis',
    'tutorial.skipForNow': 'Skip for now',
    'tutorial.nextTool': 'Next Tool',
    'tutorial.prevTool': 'Previous Tool',
    'tutorial.complete': 'Complete Tutorial',
    'tutorial.gotIt': 'Got it',
    'tutorial.helpButton': 'Help',
    'tutorial.watchTutorial': 'Watch Tutorial',

    // Onboarding
    'onboarding.skip': 'Skip',
    'onboarding.previous': 'Previous',
    'onboarding.next': 'Next',
    'onboarding.getStarted': 'Start Exploring',
    'onboarding.welcomeStep': 'Welcome',
    'onboarding.rectangleStep': 'Rectangle Tool',
    'onboarding.pointStep': 'Point Tool',
    'onboarding.strategyBuilderStep': 'Strategy Builder',
    'onboarding.aiAgentStep': 'AI Agent',
    'onboarding.welcomeTitle': 'Welcome to Alphora AI',
    'onboarding.welcomeSubtitle': 'Next-Gen AI Quant Chart Studio',
    'onboarding.welcomeDescription': 'We\'re building the next generation of AI-powered quantitative analysis platform. Currently in Alpha testing - some features are still being optimized. Thank you for your support and feedback!',
    'onboarding.alphaNotice': '🚀 Alpha Version - Continuously Evolving',
    'onboarding.toolsIntro': 'Here are the powerful tools available:',
    'onboarding.feature1': 'AI Rectangle Analysis',
    'onboarding.feature1Desc': 'AI-powered pattern recognition engine that intelligently matches historical similar K-line intervals and predicts future trend probabilities',
    'onboarding.feature2': 'AI Signal Detection',
    'onboarding.feature2Desc': 'AI-powered signal detection system that automatically analyzes key points with historical similar signals and subsequent performance',
    'onboarding.feature3': 'Strategy Builder',
    'onboarding.feature3Desc': 'Quickly create and backtest quantitative strategies with intuitive entry/exit rules setup and detailed performance reports',
    'onboarding.feature4': 'AI Quant Agent',
    'onboarding.feature4Desc': 'End-to-end intelligent trading assistant that analyzes markets and generates strategy recommendations through natural language conversation',

    // User profile / subscription
    'profile.accountSettings': 'Account Settings',
    'profile.accountSettingsSubtitle': 'Manage your profile details and subscription plan.',
    'profile.badge.eliteStatus': 'Elite Status',
    'profile.badge.proMember': 'Pro Member',
    'profile.badge.currentPlan': 'Current Plan',
    'profile.badge.active': 'Active',
    'profile.plan.usageTitle': 'Daily AI Analysis',
    'profile.plan.tokensUsed': '{{used}} / {{limit}} tokens used',
    'profile.plan.manage': 'Manage Plan',
    'profile.plan.upgrade': 'Upgrade Plan',
    'profile.plan.manageSubscription': 'Manage subscription',
    'profile.security.title': 'Security',
    'profile.security.twoFactor': 'Two-Factor Auth',
    'profile.security.twoFactorSubtitle': 'Enabled via Email',
    'profile.security.password': 'Password',
    'profile.security.passwordSubtitle': 'Last changed 1mo ago',
    'profile.security.update': 'Update',
    'profile.personalInfo.title': 'Personal Information',
    'profile.personalInfo.firstName': 'First Name',
    'profile.personalInfo.lastName': 'Last Name',
    'profile.personalInfo.edit': 'Edit',
    'profile.personalInfo.cancel': 'Cancel',
    'profile.personalInfo.save': 'Save',
    'profile.invite.title': 'Invite Friends',
    'profile.invite.subtitle': 'Get +50 AI tokens for each referral',
    'profile.invite.button': 'Invite',
    'profile.plan.renewsOn': 'Renews on {{date}}',
    'profile.plan.endsOn': 'Ends on {{date}}',
    'profile.messages.mustLoginUpdateProfile': 'You must be logged in to update profile.',
    'profile.messages.updateFailed': 'Failed to update profile',
    'profile.messages.updateSuccess': 'Profile updated successfully',
    'profile.messages.planUpgraded': 'Plan upgraded to {{plan}}',
    'profile.messages.mustLoginManageSub': 'You must be logged in to manage your subscription.',
    'profile.messages.billingPortalFailed': 'Failed to open billing portal.',

    // Plan selection
    'plans.title': 'Choose the right plan for your trading journey',
    'plans.subtitle': 'Upgrade or downgrade at any time. Unlock the power of AI-driven market analysis.',
    'plans.backToProfile': 'Back to Profile',
    'plans.mostPopular': 'Most Popular',
    'plans.starter.description': 'Perfect for getting started with basic chart analysis.',
    'plans.starter.feature.standardIndicators': 'Standard indicators',
    'plans.starter.feature.dailyTokens': '5 AI Analysis tokens / day',
    'plans.pro.description': 'Real-time data and advanced AI tools for serious traders.',
    'plans.pro.feature.advancedIndicators': 'Advanced indicators (MACD, RSI, etc.)',
    'plans.pro.feature.dailyTokens': '50 AI Analysis tokens / day',
    'plans.pro.feature.prioritySupport': 'Priority Support',
    'plans.enterprise.description': 'Unlimited power for high-volume trading and wealth management.',
    'plans.enterprise.feature.unlimitedAI': 'Unlimited AI Analysis',
    'plans.enterprise.feature.accountManager': 'Dedicated Account Manager',
    'plans.enterprise.feature.apiAccess': 'API Access',
    'plans.enterprise.feature.customStrategy': 'Custom Strategy Development',
    'plans.button.currentPlan': 'Current Plan',
    'plans.button.notAvailable': 'Not available on current plan',
    'plans.button.contactSales': 'Contact Sales',
    'plans.button.selectPlan': 'Select Plan',
    'plans.messages.alreadyStarter': 'You are already on the Starter plan.',
    'plans.messages.priceIdNotConfigured': 'Configuration error: Price ID not configured.',
    'plans.messages.mustLoginUpgrade': 'You must be logged in to upgrade.',
    'plans.messages.createCheckoutFailed': 'Failed to create checkout session',
    'plans.messages.upgradeFailed': 'Failed to initiate upgrade: {{error}}',
    
    // Strategy Builder
    'nav.strategies': 'Strategies',
    'strategyBuilder.buildStrategy': 'Build Strategy',
    'strategyBuilder.editStrategy': 'Edit Strategy',
    'strategyBuilder.myStrategies': 'My Strategies',
    'strategyBuilder.createNew': 'New Strategy',
    'strategyBuilder.createFirst': 'Create your first strategy',
    'strategyBuilder.noStrategies': 'No strategies yet',
    'strategyBuilder.strategyName': 'STRATEGY NAME',
    'strategyBuilder.namePlaceholder': 'Name',
    'strategyBuilder.asset': 'ASSET',
    'strategyBuilder.timeframe': 'TIMEFRAME',
    'strategyBuilder.buyConditions': 'BUY CONDITIONS',
    'strategyBuilder.sellConditions': 'SELL CONDITIONS',
    'strategyBuilder.addSignal': 'ADD SIGNAL',
    'strategyBuilder.searchSignals': 'Search signals...',
    'strategyBuilder.selectBuySignal': 'Select Buy Signal',
    'strategyBuilder.selectSellSignal': 'Select Sell Signal',
    'strategyBuilder.noSignalsSaved': 'No signals saved yet. Create signals from Chart Analysis first.',
    'strategyBuilder.noSignalsMatch': 'No signals match your search',
    'strategyBuilder.noSignalsForFilter': 'No signals found for this asset and timeframe. Create matching signals first.',
    'strategyBuilder.useSignalExit': 'Use sell signal',
    'strategyBuilder.takeProfit': 'Take Profit',
    'strategyBuilder.stopLoss': 'Stop Loss',
    'strategyBuilder.maxHoldingPeriod': 'Max Holding Period',
    'strategyBuilder.hours': 'hours',
    'strategyBuilder.days': 'days',
    'strategyBuilder.tpslBackup': 'TP/SL acts as backup exit when using signal',
    'strategyBuilder.saveStrategy': 'Save Strategy',
    'strategyBuilder.backtestResults': 'Backtest Results',
    'strategyBuilder.backtestComplete': 'Backtest completed',
    'strategyBuilder.backtestFailed': 'Backtest failed',
    'strategyBuilder.setExitRule': 'Please set take profit or stop loss',
    'strategyBuilder.enterName': 'Please enter a strategy name',
    'strategyBuilder.saveSuccess': 'Strategy saved successfully',
    'strategyBuilder.saveFailed': 'Failed to save strategy',
    'strategyBuilder.loadFailed': 'Failed to load strategies',
    'strategyBuilder.deleteSuccess': 'Strategy deleted',
    'strategyBuilder.deleteFailed': 'Failed to delete strategy',
    'strategyBuilder.confirmDelete': 'Delete this strategy?',
    'strategyBuilder.viewDetails': 'View',
    'strategyBuilder.createdAt': 'Created',
    'strategyBuilder.exitRule': 'Exit',
    'strategyBuilder.signalBased': 'Signal-based',
    'strategyBuilder.time': 'Time',
    'strategyBuilder.desc': 'Desc',
    'strategyBuilder.summaryTab': 'Summary',
    'strategyBuilder.tradesTab': 'Trade History',
    'strategyBuilder.winRate': 'Win Rate',
    'strategyBuilder.totalReturn': 'Total Return',
    'strategyBuilder.sharpeRatio': 'Sharpe Ratio',
    'strategyBuilder.maxDrawdown': 'Max Drawdown',
    'strategyBuilder.profitFactor': 'Profit Factor',
    'strategyBuilder.totalTrades': 'Total Trades',
    'strategyBuilder.avgReturn': 'Avg Return/Trade',
    'strategyBuilder.avgHolding': 'Avg Holding Period',
    'strategyBuilder.sampleSize': 'Sample Size',
    'strategyBuilder.lowConfidence': 'Low statistical confidence',
    'strategyBuilder.entryTime': 'Entry Time',
    'strategyBuilder.entryPrice': 'Entry Price',
    'strategyBuilder.exitTime': 'Exit Time',
    'strategyBuilder.exitPrice': 'Exit Price',
    'strategyBuilder.return': 'Return',
    'strategyBuilder.holdingPeriod': 'Hold Time',
    'strategyBuilder.exitReason': 'Exit Reason',
    'strategyBuilder.trades': 'Trades',
    'strategyBuilder.selectThisSignal': 'Select This Signal',
    'strategyBuilder.strategyPerformance': 'Strategy Performance',
    'strategyBuilder.askFollowUp': 'Ask a follow-up...',
    'strategyBuilder.waitingForAnalysis': 'Waiting for AI analysis...',
    'strategyBuilder.equityCurve': 'Equity Curve',
    'strategyBuilder.clickToExpand': 'Click to expand',
    'strategyBuilder.recentTrades': 'Recent Trades',
    'strategyBuilder.strategy': 'Strategy',
    'strategyBuilder.library': 'Library',
    'strategyBuilder.selectStrategy': 'Select Strategy',
    'strategyBuilder.selectOrBuildStrategy': 'Select a strategy or build a new one',
    'strategyBuilder.askAboutStrategy': 'Ask AI about strategy performance...',
    'strategyBuilder.strategyLog': 'Strategy Log',
    'strategyBuilder.description': 'Description',
    'strategyBuilder.descriptionPlaceholder': 'Describe this strategy...',
    // Futures trading
    'strategyBuilder.tradingMode': 'Trading Mode',
    'strategyBuilder.spot': 'Spot',
    'strategyBuilder.futures': 'Futures',
    'strategyBuilder.direction': 'Direction',
    'strategyBuilder.long': 'Long',
    'strategyBuilder.short': 'Short',
    'strategyBuilder.leverage': 'Leverage',
    'strategyBuilder.leverageWarning': '{{pct}}% adverse move = liquidation',
    'strategyBuilder.liquidations': 'liquidations',
    'common.select': 'Select',
    'common.back': 'Back',
  }
};

// 检测浏览器语言
const getBrowserLanguage = () => {
  const browserLang = navigator.language || navigator.languages?.[0] || 'en-US';
  // 如果浏览器语言是中文，返回中文，否则返回英文
  return browserLang.startsWith('zh') ? 'zh-CN' : 'en-US';
};

i18n
  .use(initReactI18next)
  .init({
    resources: {
      'zh-CN': zhCN,
      'en-US': enUS,
    },
    lng: localStorage.getItem('language') || getBrowserLanguage(),
    fallbackLng: 'en-US', // 默认英文
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n; 
